import { render, staticRenderFns } from "./KeyCommon.vue?vue&type=template&id=47c993df&scoped=true&"
import script from "./KeyCommon.vue?vue&type=script&lang=js&"
export * from "./KeyCommon.vue?vue&type=script&lang=js&"
import style0 from "./KeyCommon.vue?vue&type=style&index=0&id=47c993df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c993df",
  null
  
)

export default component.exports